import { Typography } from "@/design-system/Atoms"; 

type PrivacyPolicyLayoutProps = {
  heading?: string;
  content?: string | React.ReactNode;
  className?: string;
};

export const PrivacyPolicyLayout = ({
  heading,
  content,
  className,
}: PrivacyPolicyLayoutProps) => {
  return (
    <>
      <Typography variant="privacyPolicyTitle" as="div" className={`${className}`}>
        {heading}
      </Typography> 

      <Typography variant="privacyPolicyDescription" as="p">
        {content}
      </Typography> 
    </>
  );
};

export default PrivacyPolicyLayout;
